



























import {Vue, Component, Watch, Prop} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {RegistrationRequest} from '@/store/modules/registration'
import {TermOfServicesState} from '@/store/modules/termOfServices'
import {TosResponse} from '@/lib/interfaces'
import Utils from '@/utils'
import Stepper from '@/components/stepper.vue'
import {AxiosError} from 'axios'

@Component({
  name: 'TermsOfService',
  components: {Stepper},
})
export default class TermsOfService extends Vue {
  @State('registration') public registrationState!: RegistrationRequest
  @State('termOfServices') public TermsOfServiceState!: TermOfServicesState
  @Action('updateRegistration') public updateRegistration: any
  @Action('sendRegistration') public sendRegistration: any
  @Action('purge') public purgeStore: any

  public downloadRequired: boolean = false

  protected downloadedTos: string[] = []
  protected approvedTos: string[] = []


  public wasApproved(el: TosResponse): boolean {
    if (!this.approvedTos) {
      return false
    }
    return this.approvedTos.includes(el.id)
  }

  public hasDownloaded(el: TosResponse): boolean {
    if (this.downloadRequired) {
      return this.downloadedTos.includes(el.id)
    }
    return true
  }

  public downloadTos(el: TosResponse) {
    if (el.attachment) {
      window.open(el.attachment, '_blank')
      if (!this.hasDownloaded(el)) {
        this.downloadedTos.push(el.id)
      }
    }
  }

  public approveTos(el: TosResponse) {
    let i
    if (!this.approvedTos) {
      i = -1
    } else {
      i = this.approvedTos.findIndex((id: string) => id === el.id)
    }

    if (i === -1) {
      this.approvedTos.push(el.id)
    } else if (el.optional) {
      this.approvedTos.splice(i, 1)
    }
  }

  public fileName(path: string) {
    const a = path.split('/')
    return a[a.length - 1]
  }

  public get allTosApproved() {
    if (this.TermsOfServiceState.tos) {
      return this.TermsOfServiceState.tos.every((t) => {
        return this.wasApproved(t) || t.optional
      })
    }
  }

  public acceptOrBack(val: number) {
    if (val > 0 && this.allTosApproved) {
      this.updateRegistration({
        accepted_tocs_id: this.approvedTos,
      })
      this.sendRegistration().then((r: any) => {
        this.purgeStore()
        // TODO: store response for thank you page
        this.$router.push({name: 'thanks'})
      }).catch((e: AxiosError) => {
        return e.response
      })
    }
    if (val < 0) {
      this.$emit('back', -1)
    }
  }

  protected mounted() {
    if (!this.registrationState.accepted_tocs_id) {
      this.updateRegistration({accepted_tocs_id: []})
    }
    if (Utils.getProp(this.registrationState as any, ['accepted_tocs_id'])) {
      this.approvedTos = Utils.getProp(this.registrationState as any, ['accepted_tocs_id'])
    }
  }
}
